'use client';

import { useEffect } from 'react';
import { ErrorCode, getErrorMessage, parseErrorObject, reportError } from '@/utils/errors';
import ErrorFallback from './ui/common/error-fallback';

export default function GlobalError({ error }: { error: Error }) {
  const errorObject = parseErrorObject(error);
  const errorMessage = getErrorMessage(errorObject.code as ErrorCode);

  useEffect(() => {
    reportError(error, {
      componentStack: error.stack,
    });
  }, [error]);

  return (
    <html>
      <head>
        <meta charSet='utf-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <title>오류가 발생했습니다</title>
      </head>
      <body>
        <div className='w-full h-screen flex items-center justify-center p-5'>
          <ErrorFallback
            errorCode={errorObject.code as ErrorCode}
            errorMessage={errorMessage}
            onRetry={() => window.location.reload()}
          />
        </div>
      </body>
    </html>
  );
}
